import SpriteSymbol from "../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tick",
  "use": "tick-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol viewBox=\"0 0 21 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tick\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.0698 6.23609L17.7087 3.87498L5.9031 15.6805L2.36144 12.1389L0.000325317 14.5L3.54199 18.0416L5.9031 20.4028L8.26421 18.0416L20.0698 6.23609Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol